import Logo from "@agrigate/shared-web-ui/lib/assets/images/logo.png";
import {
    MenuContent,
    MenuItem,
    MenuRoot,
    MenuTrigger,
} from "@agrigate/shared-web-ui/lib/components/ui/menu";
import { sessionAtom } from "@agrigate/shared-web-ui/lib/stores/session";
import { Flex, IconButton, Image } from "@chakra-ui/react";
import { useSetAtom } from "jotai";
import type { ReactElement } from "react";
import { LuUserRound } from "react-icons/lu";

const CommonHeader = (): ReactElement => {
    const setSession = useSetAtom(sessionAtom);

    return (
        <Flex
            justify={"space-between"}
            align={"center"}
            bgColor={"citric.500"}
            px={"20px"}
            py={"10px"}
        >
            <Image src={Logo} w={150} />
            <MenuRoot>
                <MenuTrigger asChild>
                    <IconButton
                        variant="ghost"
                        aria-label="User menu"
                        borderRadius="full"
                        border="2px solid"
                        borderColor="white"
                        color="white"
                        _hover={{ bg: "transparent" }}
                        _focus={{ bg: "transparent" }}
                        _active={{ bg: "transparent" }}
                    >
                        <LuUserRound size={28} />
                    </IconButton>
                </MenuTrigger>
                <MenuContent>
                    <MenuItem value="logout" onClick={() => setSession(null)}>
                        Log out
                    </MenuItem>
                </MenuContent>
            </MenuRoot>
        </Flex>
    );
};

export default CommonHeader;
